import SvgPanZoom from 'svg-pan-zoom';

// Pins are rendered larger on narrow viewports, so the map is allowed to zoom further there
export const mapMaxZoom = () => (window.innerWidth < 768 ? 30 : 20);

// Shared zoom/pan for the references maps. Spread into an Alpine component and
// call initMapZoom() from its init(); $root must contain the .imwa__map__image
// SVG and the Map component's +/- buttons. Pins keep constant screen size via
// pinTranslatePosition (needs data-transform + data-pin-size on each pin).
export const mapZoom = () => ({
    map: null,
    zoom: 1,
    // read by the Map component's +/- buttons to disable them at the limits
    maxZoom: mapMaxZoom(),

    initMapZoom() {
        const mapImage = this.$root.querySelector('.imwa__map__image');
        if (!mapImage) {
            return;
        }
        const isMobile = window.innerWidth < 768;
        this.maxZoom = mapMaxZoom();
        this.map = new SvgPanZoom(mapImage, {
            zoomEnabled: true,
            zoomScaleSensitivity: 0.5,
            controlIconsEnabled: false,
            dblClickZoomEnabled: false,
            mouseWheelZoomEnabled: false,
            fit: true,
            center: true,
            minZoom: 1,
            maxZoom: this.maxZoom,
        });
        if (isMobile) {
            this.map.zoomIn();
            this.map.pan({ x: -20, y: 0 });
        }
        this.zoom = this.map.getZoom();
    },

    zoomIn() {
        this.applyZoom(() => this.map.zoomIn());
    },

    zoomOut() {
        this.applyZoom(() => this.map.zoomOut());
    },

    applyZoom(change) {
        if (!this.map) {
            return;
        }
        change();
        this.zoom = this.map.getZoom();
        // pinClustering hooks in here to re-cluster at the new zoom level
        if (typeof this.onMapZoomChanged === 'function') {
            this.onMapZoomChanged();
        }
    },

    pinTranslatePosition($el) {
        const translate = $el.getAttribute('data-transform') || '';
        const pinSizeData = $el.getAttribute('data-pin-size');
        if (!pinSizeData) {
            return translate;
        }
        let zoomFactor = Math.min(2 / this.zoom, 1);
        if (window.innerWidth < 768) {
            zoomFactor = zoomFactor * 1.5;
        }
        const pinSize = JSON.parse(pinSizeData);
        return `${translate} translate(${(pinSize.width / 2) * (1 - zoomFactor)}, ${pinSize.height * (1 - zoomFactor)}) scale(${zoomFactor})`;
    },
});
